function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 36 28",
  fill: "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.65 2.47h21.157v22.37H11.65V2.47zm-2.47 0H2.47v4.56h6.71V2.47zm0 7.03H2.47v15.34h6.71V9.5zM0 27.31V0h35.277v27.31H0zM25 6h-5v5h5V6zm3.91 10.81H16.187v-2.47H28.91v2.47zm-12.723 4.155h8.675v-2.47h-8.674v2.47z",
  fill: "#354147"
})));